import { render, staticRenderFns } from "./TotalTagsScanned.vue?vue&type=template&id=cf30d8c6"
import script from "./TotalTagsScanned.vue?vue&type=script&lang=ts"
export * from "./TotalTagsScanned.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports